import Base from '../../../Base/Base';
import Styles from './WorkQueueResults.module.scss';
import Grid from '@mui/material/Grid';

import RequestsTable from '../RequestsTable/RequestsTable';
import { WQAccordion } from '../../../../components/UI/WQAccordion/WQAccordion';

/**
 * Wrapping component for Work Queue Page
 *
 * @returns rendered component.
 */

const WorkQueueResults = () => {
	// For RequestsTable component to work on work queue results page, need to have ID of -1 to not filter based on a work queue system, but rather all requests assigned to you
	// For RequestsTable component for Admin page, we need to have a systemID to return results associated with that system only
	const currentSystem = { ID: -1 };

	// const switchToLegacy = () => {
	// 	window.top.location.href = `/${determineIfExternal(
	// 		`/workqueue/wqsearch.aspx`
	// 	)}`;
	// };

	return (
		<Base title={'Work Queue'} className={Styles['base--default']}>
			<Grid
				container
				direction='column'
				spacing={3}
				sx={{ alignItems: 'center' }}
			>
				<Grid item>
					{/* <Subtitle2
						className={Styles['subtitle2--link--default']}
						onClick={switchToLegacy}
					>
						Switch to Legacy View
					</Subtitle2> */}
					<WQAccordion
						title={'Requests'}
						subTitle={'Your Assigned Work Queue Requests'}
					>
						<RequestsTable {...{ currentSystem }} admin={false} />
					</WQAccordion>
				</Grid>
			</Grid>
		</Base>
	);
};

export default WorkQueueResults;
